/*
  Project: Congo Research Group
  Author: xfive
 */

import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/blur-up/ls.blur-up';



// WEBPACK FOOTER //
// ./src/scripts/vendor/lazyload.js